<template>
    <b-modal id="modal-valueYChart" ref="modalValueYChart" size="lg" title="Impostazoni grafico" :hide-footer="true">
        <h4>Asse Y</h4>
        <div class="row">
            <div class="col">
                <label class="label-control d-block">Valore minimo:</label>
                <input type="number" class="form-control mb-2" v-model="valueYMin" :disabled="valueYMinAuto" />
                <label>
                    <input type="checkbox" v-model="valueYMinAuto" />
                    <span>Automatico</span>
                </label>
            </div>
            <div class="col">
                <label class="label-control d-block">Valore massimo:</label>
                <input type="number" class="form-control mb-2" v-model="valueYMax" :disabled="valueYMaxAuto" />
                <label>
                    <input type="checkbox" v-model="valueYMaxAuto" />
                    <span>Automatico</span>
                </label>
            </div>
        </div>
        
        <div class="d-flex justify-content-end mt-5">
            <b-btn variant="secondary" class="mr-2" @click="$bvModal.hide('modal-valueYChart')">Annulla</b-btn>
            <b-btn variant="primary" @click="editValueYChart()">Applica</b-btn>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            valueYMin: null,
            valueYMax: null,
            valueYMinAuto: true,
            valueYMaxAuto: true
        }
    },
    methods: {
        editValueYChart() {
            if(this.valueYMin != null) {
                this.valueYMin = parseInt(this.valueYMin);
            }

            if(this.valueYMax != null) {
                this.valueYMax = parseInt(this.valueYMax);
            }

            if(this.valueYMin == null && ! this.valueYMinAuto) {
                this.$notify({
                    type: "error",
                    text: "Inserire il valore minimo o selezionare automatico",
                    title: 'Errore',
                });
                return;
            }

            if(this.valueYMax == null && ! this.valueYMaxAuto) {
                this.$notify({
                    type: "error",
                    text: "Inserire il valore massimo o selezionare automatico",
                    title: 'Errore',
                });
                return;
            }

            if(this.valueYMin && this.valueYMax && this.valueYMin > this.valueYMax) {
                this.$notify({
                    type: "error",
                    text: "Il valore massimo deve essere superiore rispetto a quello minimo",
                    title: 'Errore',
                });
                return;
            }
            
            this.$emit("reload", this.valueYMin, this.valueYMax);

            this.$refs.modalValueYChart.hide();
        },
    },
    watch: {
        valueYMinAuto() {
            this.valueYMin = null;
        },
        valueYMaxAuto() {
            this.valueYMax = null;
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Charts/Types/Am/ValueYChartModal.vue